export default __webpack_public_path__ + "locales/lo-LA/Webhooks.json?hash=d7d103110d154aed7626b0c028c21af2";